module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/example-1-f82fe63c04dcd8bf692e9115d58d106e.png";